module.exports = __webpack_public_path__ + "img/16.33582a01.png";